import { c as _c } from "react/compiler-runtime";
import { SelectCompanyRole } from "@components/role/select-company-role";
import { MemberRoleReadOnly } from "@components/table/members/members-column/role-column/member-role-read-only";
import { useHasUserValidRoleCompanyLevel } from "@hooks/access-control/use-has-user-valid-role-company-level";
import { useHasUserValidFeatureCompanyLevel } from "@hooks/feature-control/use-has-user-valid-feature-company-level";
import { useChangeWorkspaceRole } from "@hooks/use-change-workspace-role";
import { useAppSelector } from "@store/store-helper";
import { currentUserSelector } from "@store/user/user-selector";
import { FaroButtonSpinner } from "@components/common/button/faro-button-spinner";
import { Stack } from "@mui-wrapper";
import { getAssignableWorkspaceRoles } from "@utils/workspace-role-utils";
/**
 * Render and adjust member roles in company context.
 * This dropdown is showed to change the role for a single member inside a table.
 */
export function CompanyMemberRole(t0) {
  const $ = _c(27);
  const {
    companyId,
    memberIdentityRole,
    isReadOnly: t1,
    variant,
    menuProps,
    location,
    teamName,
    member
  } = t0;
  const isReadOnly = t1 === undefined ? false : t1;
  const currentUser = useAppSelector(currentUserSelector);
  const {
    canEditMember
  } = useHasUserValidRoleCompanyLevel();
  const {
    canAssignManagers
  } = useHasUserValidFeatureCompanyLevel();
  const isCurrentUser = currentUser?.identity === memberIdentityRole.identity;
  let t2;
  if ($[0] !== companyId || $[1] !== location || $[2] !== member || $[3] !== memberIdentityRole.identity || $[4] !== memberIdentityRole.role || $[5] !== teamName) {
    t2 = {
      companyId,
      memberIdentity: memberIdentityRole.identity,
      currentRole: memberIdentityRole.role,
      member,
      location,
      teamName
    };
    $[0] = companyId;
    $[1] = location;
    $[2] = member;
    $[3] = memberIdentityRole.identity;
    $[4] = memberIdentityRole.role;
    $[5] = teamName;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const {
    changeRole,
    isUpdating,
    xgSeatDialog
  } = useChangeWorkspaceRole(t2);
  if (isReadOnly) {
    let t3;
    if ($[7] !== memberIdentityRole.role || $[8] !== variant) {
      t3 = <MemberRoleReadOnly role={memberIdentityRole.role} variant={variant} />;
      $[7] = memberIdentityRole.role;
      $[8] = variant;
      $[9] = t3;
    } else {
      t3 = $[9];
    }
    return t3;
  }
  if (isCurrentUser || !canEditMember) {
    let t3;
    if ($[10] !== memberIdentityRole.role || $[11] !== variant) {
      t3 = <MemberRoleReadOnly role={memberIdentityRole.role} variant={variant} />;
      $[10] = memberIdentityRole.role;
      $[11] = variant;
      $[12] = t3;
    } else {
      t3 = $[12];
    }
    return t3;
  }
  const t3 = memberIdentityRole.role;
  let t4;
  if ($[13] !== canAssignManagers) {
    t4 = getAssignableWorkspaceRoles("change", canAssignManagers);
    $[13] = canAssignManagers;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  let t5;
  if ($[15] !== changeRole || $[16] !== menuProps || $[17] !== t3 || $[18] !== t4 || $[19] !== variant) {
    t5 = <SelectCompanyRole selectedRole={t3} onChange={changeRole} variant={variant} menuProps={menuProps} roles={t4} />;
    $[15] = changeRole;
    $[16] = menuProps;
    $[17] = t3;
    $[18] = t4;
    $[19] = variant;
    $[20] = t5;
  } else {
    t5 = $[20];
  }
  let t6;
  if ($[21] !== isUpdating) {
    t6 = isUpdating && <FaroButtonSpinner size="14px" />;
    $[21] = isUpdating;
    $[22] = t6;
  } else {
    t6 = $[22];
  }
  let t7;
  if ($[23] !== t5 || $[24] !== t6 || $[25] !== xgSeatDialog) {
    t7 = <Stack direction="row" onClick={_temp}>{t5}{t6}{xgSeatDialog}</Stack>;
    $[23] = t5;
    $[24] = t6;
    $[25] = xgSeatDialog;
    $[26] = t7;
  } else {
    t7 = $[26];
  }
  return t7;
}
function _temp(event) {
  return event.stopPropagation();
}